import { MdNearMe } from "react-icons/md"

import { abrirVagaNoGps, montarTextoEnderecoVaga } from "../../../servicos/gestaoVagaGps"

/**
 * Endereço (~75%) + atalho GPS com ícone (~25%).

 */

export default function GestaoVagaEnderecoGpsRow({ vaga, onErroGps, className = "" }) {
	const texto = montarTextoEnderecoVaga(vaga)
	if (!texto) {
		return null
	}

	return (
		<div className={`gv-endereco-gps-row ${className}`.trim()}>
			<p className="gv-endereco-gps-row__texto m-0">{texto}</p>
			<button
				type="button"
				className="gv-endereco-gps-row__gps"
				aria-label="Abrir endereço no GPS"
				title="Abrir no GPS"
				onClick={() => {
					if (!abrirVagaNoGps(vaga)) {
						onErroGps?.("Endereço ou coordenadas da vaga não disponíveis para o GPS.")
					}
				}}
			>
				<MdNearMe size={22} aria-hidden />
			</button>
		</div>
	)
}
